import React from 'react';
import { ProductTile } from '@hpstellar/core';

import Link from '../../../shared/components/hyperlink';
import { getProductShowcaseProps } from '../../../product/get-product-props/index';
import useProductPrice from '../../../hooks/useProductPrice';
import './product-carousel-card.less';

const productCarouselCard = props => {
    const { sku } = props.product || {};
    const { prices } = useProductPrice([props.product]);
    const productProps = getProductShowcaseProps(props.product, prices[sku]);
    const { product, productLinkProps } = productProps;

    return (
        <Link
            className="blog-product-tile"
            newTab={true}
            to={product.productUrl}
            style={{ textDecoration: 'none', color: 'black' }}
        >
            <ProductTile
                className="carouselShowcaseTile"
                {...productProps}
                isDisplaySku={false}
                ratingSpaceReserved={true}
                translations={{
                    buttons: {
                        productLinkBtnText: 'See Product',
                    },
                }}
            />
        </Link>
    );
};

export default productCarouselCard;
